import { defineStore } from 'pinia'
import { GetGlobalsDocument } from '#graphql-exports'

import type { LegalPages, Settings } from '#payload-types'

interface GlobalStats {
  pledges: number
  schools: number
}

interface GlobalQueryResult {
  Settings: Settings
  GlobalStats: GlobalStats
  LegalPages: LegalPages
}

export const useGlobalsStore = defineStore('globals', () => {
  const cardBackgroundClasses = ['bg-mint', 'bg-pink', 'bg-yellow', 'bg-blue']
  const getCardBackgroundClass = (index: number) =>
    cardBackgroundClasses[index % cardBackgroundClasses.length]

  const settings = ref<Settings | null>(null)
  const globalStats = ref<GlobalStats | null>(null)
  const legalPages = ref<LegalPages | null>(null)

  const load = () => {
    return useAsyncQuery<GlobalQueryResult>(GetGlobalsDocument).then(
      ({ data }) => {
        settings.value = data.value?.Settings || null
        globalStats.value = data.value?.GlobalStats || null
        legalPages.value = data.value?.LegalPages || null
      },
    )
  }

  return {
    cardBackgroundClasses,
    getCardBackgroundClass,
    settings,
    globalStats,
    legalPages,
    load,
  }
})
